import {useEffect} from 'react'

const useAriaHiddenOnIframesAndDividers = () => {
    useEffect(() => {
        const setAriaHidden = () => {
            // Set aria-hidden on all iframes
            document.querySelectorAll('iframe').forEach((iframe) => {
                iframe.setAttribute('aria-hidden', 'true')
            })
            // Set aria-hidden on all Chakra UI dividers
            document.querySelectorAll('hr.chakra-divider').forEach((divider) => {
                divider.setAttribute('aria-hidden', 'true')
                divider.removeAttribute('role')
                divider.removeAttribute('aria-orientation')
            })
        }
        setAriaHidden()
        const observer = new MutationObserver(setAriaHidden)
        observer.observe(document.body, {childList: true, subtree: true})
        return () => observer.disconnect()
    }, [])
}

export default useAriaHiddenOnIframesAndDividers
